// "Look here first" summary band for data-table-heavy deterministic checks. Visually
// borrows the LLM-verdict purple shell so the same vocabulary signals "this is interpretive
// content drafted by Claude" wherever it appears — judgment-row verdicts AND data-card
// summaries share one visual language.
//
// Distinct from LlmVerdictDisplay: the summary doesn't carry a confidence indicator (it's
// summarizing computed-deterministic results, not making a judgment call) and has no
// separate "grounded in" section (the structured evidence below the summary IS the grounding).

import ReactMarkdown from 'react-markdown';

interface FindingSummaryProps {
  summary: string;
}

export const FindingSummary = ({ summary }: FindingSummaryProps) => (
  <div className='finding-summary'>
    <div className='finding-summary__header'>
      <span className='finding-summary__label'>Drafted by Claude</span>
    </div>
    <div className='finding-summary__text'>
      <ReactMarkdown
        allowedElements={['p', 'strong', 'em', 'ul', 'ol', 'li', 'br']}
        unwrapDisallowed
      >
        {summary}
      </ReactMarkdown>
    </div>
  </div>
);
